import React from 'react';
import View from '@src/components/view';
import RouteLoadingImage from '@src/components/route/route-loading/route-loading-image';
import TextDotAnimation from '@src/components/text-dot-animation';
import ReactDOM from 'react-dom';
import DelayShow from '@src/components/delay-show';

// noinspection JSUnresolvedFunction
const styles = require('./index.less');

export default class RouteLoading extends React.PureComponent {
  static defaultProps = {
    /**
     * 加载 loadingText 文案
     */
    loadingText: '努力加载中',
    /**
     * 延迟展示, 如果在网速很快的情况下, 如 100 毫秒内销毁当前组件, 则不展示任何内容
     */
    delayShow: 150,
    /**
     * loading图片类型，有剑三loading, 西山居loading，小黄鸡loading
     */
    loadingImageType: RouteLoadingImage.LOADING_IMAGE_TYPE.SEASUN_ICON
  };

  constructor(props) {
    super(props);
    this.containerEl = document.createElement('div');
    this.state = {
      isReady: false
    };
    this.onRouteLoadingImageReady = ::this.onRouteLoadingImageReady;
  }

  componentDidMount() {
    document.body.appendChild(this.containerEl);
  }

  onRouteLoadingImageReady() {
    this.setState({ isReady: true });
  }

  componentWillUnmount() {
    document.body.removeChild(this.containerEl);
  }

  render() {
    const { loadingText, delayShow: delay, loadingImageType, ...restProps } = this.props;
    const { isReady } = this.state;
    return ReactDOM.createPortal(
      <DelayShow delay={delay}>
        <View css={styles.root} {...restProps} style={{ display: isReady ? undefined : 'none' }}>
          <RouteLoadingImage onReady={this.onRouteLoadingImageReady} loadingImageType={loadingImageType} />
          <TextDotAnimation className={styles.text}>{loadingText}</TextDotAnimation>
        </View>
      </DelayShow>,
      this.containerEl
    );
  }
}
